import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignPermalinks } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignPermalinkFilters, CampaignPermalinks, CampaignPermalinksSlice } from "types/campaign/permalinks";
import { generateUniqueKey, isFresh } from "utils/helpers";

export const fetchCampaignPermalinksThunk = createAsyncThunk<{permalinks: CampaignPermalinks, filters: CampaignPermalinkFilters, filterId: string, campaignId: string}, {campaignId: string, force?: boolean, filters: CampaignPermalinkFilters}, {rejectValue: string}>(
    'campaign/permalinks',
    async ({campaignId, force, filters}, {getState, rejectWithValue}) => {
        try {
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_IG_PERMALINKS.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as {auth: AuthState, campaignPermalinks: CampaignPermalinksSlice};
            if(filters.page === 1 && !force && isFresh(state.campaignPermalinks.campaigns[campaignId]?.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)){
                rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgencyId ?? '';
            if(!agencyId) throw new Error("AgencyId not found");

            const permalinks = await fetchCampaignPermalinks(campaignId, agencyId, filters);

            return {permalinks, filters, filterId, campaignId};

        } catch (error) {
            return rejectWithValue('Failed to fetch campaign applications');
        }
    }
)